export const keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};

export const focusableElements = [
  'a[href]',
  'area[href]',
  'input:not([disabled]):not([type=hidden])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  'object',
  'embed',
  '[tabindex]:not(.modal):not([tabindex="-1"])',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])'
];

export const TransitionTimeouts = {
  Fade: 150,
  Collapse: 350,
  Modal: 300,
  Carousel: 600
};

export const TransitionPropTypeKeys = [
  'in',
  'mountOnEnter',
  'unmountOnExit',
  'appear',
  'enter',
  'exit',
  'timeout',
  'onEnter',
  'onEntering',
  'onEntered',
  'onExit',
  'onExiting',
  'onExited'
];

export const TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

export const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export function omit<T extends object>(obj: T, keys: readonly (keyof T | string)[]): Partial<T> {
  const result: any = {};
  Object.keys(obj).forEach(key => {
    if ((keys as readonly string[]).indexOf(key) === -1) {
      result[key] = (obj as any)[key];
    }
  });
  return result;
}

export function pick<T extends object>(obj: T, keys: readonly (keyof T | string)[]): Partial<T> {
  const result: any = {};
  (keys as readonly string[]).forEach(key => {
    if (key in obj) {
      result[key] = (obj as any)[key];
    }
  });
  return result;
}

export function isObject(value: unknown): value is Record<string, unknown> {
  const type = typeof value;
  return value !== null && (type === 'object' || type === 'function');
}

export function getTarget(target: Element | string | (() => Element) | { current: Element | null }): Element | null {
  if (typeof target === 'function') {
    return target();
  }
  if (typeof target === 'string') {
    const selection = document.querySelectorAll(target);
    if (!selection.length) {
      return null;
    }
    return selection[0]!;
  }
  if (target && (target as { current?: Element }).current !== undefined) {
    return (target as { current: Element | null }).current;
  }
  return target as Element;
}

export function getScrollbarWidth(): number {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

export function setScrollbarWidth(padding: number): void {
  document.body.style.paddingRight = padding > 0 ? `${padding}px` : '';
}

export function isBodyOverflowing(): boolean {
  return document.body.clientWidth < window.innerWidth;
}

export function getOriginalBodyPadding(): number {
  const style = window.getComputedStyle(document.body, null);
  return parseInt((style && style.getPropertyValue('padding-right')) || '0', 10);
}

export function conditionallyUpdateScrollbar(): void {
  const scrollbarWidth = getScrollbarWidth();
  const fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  const bodyPadding = fixedContent ? parseInt((fixedContent as HTMLElement).style.paddingRight || '0', 10) : 0;
  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
